import I18n from "../i18n/I18n";
import Helper from "../helper/Helper";

const sideMenu = [
  {
    name: I18n.getText("menu.dashboard", {}, "Dashboard"),
    url: "/",
    icon: "dashboard",
    id: 1
  },
  // {
  //     name: I18n.getText("menu.orders", {}, "Orders"),
  //     url: "/orders",
  //     icon: "orders",
  //     id: 7
  // },
  {
    name: I18n.getText("menu.transfers"),
    url: "/transfers",
    icon: "truck",
    id: 8
  },
  {
    name: I18n.getText("menu.products", {}, "Products"),
    url: `${Helper.getSubdomain('catalog')}${Helper.getLocale()}/`,
    icon: "products",
    id: 3,
    type: 'external'
  },
  {
    name: I18n.getText("menu.statements", {}, "Statements"),
    url: "/statements",
    icon: "statements",
    id: 4
  },
  {
    name: I18n.getText("menu.reports", {}, "Reports"),
    url: "/reports",
    icon: "reports",
    id: 5
  }
];

export default sideMenu;



// WEBPACK FOOTER //
// ./src/constants/sideMenu.js